export default __webpack_public_path__ + "static/media/noImg.c08a4850.png";